import ExpansionPanel from '@material-ui/core/Accordion';
import ExpansionPanelDetails from '@material-ui/core/AccordionDetails';
import ExpansionPanelSummary from '@material-ui/core/AccordionSummary';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import WorkflowDeploymentActionDetails from './WorkflowDeploymentActionDetails';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: '0 !important'
    },
    table: { 
      tableLayout: 'fixed' 
    },
    tableCell: {
      borderBottom: 'none',
      userSelect: 'text',
      paddingRight: 4
    },
    deckIdentifierText: {
      wordBreak: 'break-all'
    }
  })
);

interface Props {
  action: any;
  accountId: string;
  region: string;
  showAdvancedSettings: boolean;
}

function WorkflowDeploymentActionExpansionPanel(props: Props) {
  const { action, accountId, region, showAdvancedSettings } = props;
  const classes = useStyles({});

  return (
    <ExpansionPanel className={classes.root}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Table size="small" className={classes.table} padding="none">
          <TableBody>
            <TableRow>
              {showAdvancedSettings && <TableCell className={classes.tableCell}>
                <Typography variant="body2">{action.ActionName}</Typography>
                {action.ActionGroup && <Typography variant="caption" color="textSecondary">{action.ActionGroup}</Typography>}
              </TableCell>}
              <TableCell className={classes.tableCell}>
                <Typography variant="body2">{action.DeckName}</Typography>
                <Typography className={classes.deckIdentifierText} variant="caption" color="textSecondary">{action.Tag || action.Version}</Typography>
              </TableCell>
              <TableCell className={classes.tableCell}>
                <Typography variant="body2">{action.DeploymentName}</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <WorkflowDeploymentActionDetails accountId={accountId} region={region} action={action} />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default WorkflowDeploymentActionExpansionPanel;
